import { CreateService, CRUDServiceInterface } from '@/services/service';
import { IssueReactionEntity } from '@/entities/issue-reaction.entity';

export default class IssueReactionService
  extends CreateService<IssueReactionEntity>('issue-reaction')
  implements CRUDServiceInterface<IssueReactionEntity>
{
  async getMany(
    commentId: string | number,
    emoticonId: string | number,
  ): Promise<IssueReactionEntity[]> {
    this.apiBuilder.reset();
    const [items] = await this.apiBuilder
      .clone()
      .join('staff')
      .filter('issueId', '$eq', String(commentId))
      .filter('emoticonId', '$eq', String(emoticonId))
      .getMany();
    return items;
  }
}
